import React, { useState, useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import MoneyInBarChart from "../../components/charts/LoanAppraisal/MoneyInBarChart";
import MoneyOutBarChart from "../../components/charts/LoanAppraisal/MoneyOutBarChart";
import { Helmet } from "react-helmet";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const LoanApprasialReport = () => {
  const { loanCode, statementType } = useParams();

  const { state } = useLocation();
  const navigate = useNavigate();
  const handleBack = () => {
    navigate(-1);
  };
  const reportRef = useRef(null);
  const [statementData, setStatementData] = useState(() => {
    return (
      state?.statementData ||
      JSON?.parse(sessionStorage?.getItem("statementData"))
    );
  });

  const handleDownloadPDF = async () => {
    const element = reportRef.current;
    if (!element) return;

    // Ensure all scrollable content is visible
    const originalOverflow = element.style.overflow;
    element.style.overflow = "visible";

    const canvas = await html2canvas(element, {
      scale: 2, // higher = sharper text
      useCORS: true,
      backgroundColor: "#F8F8F8",
    });

    element.style.overflow = originalOverflow;

    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    const imgWidth = pdfWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    heightLeft -= pdfHeight;

    while (heightLeft > 0) {
      position -= pdfHeight;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pdfHeight;
    }

    pdf.save(`Loan_Appraisal_Report_${loanCode}.pdf`);
  };

  const toNumber = (value) => {
    if (typeof value === "number") return value;
    if (typeof value === "string") return Number(value.replace(/,/g, ""));
    return 0;
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Belite || Reports</title>
      </Helmet>
      <div className="bg-[#F5F6F7] overflow-y-auto h-full px-[10px]">
        <div className="flex items-center gap-5 mt-2">
          <div
            onClick={handleBack}
            className="cursor-pointer rounded-[8px] text-[#074073] text-[12px] bg-[#BFE0FD] h-[26px] w-[70px] flex items-center justify-center gap-2"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.9375 8.4375H15.1875C15.3367 8.4375 15.4798 8.49676 15.5852 8.60225C15.6907 8.70774 15.75 8.85082 15.75 9C15.75 9.14918 15.6907 9.29226 15.5852 9.39775C15.4798 9.50324 15.3367 9.5625 15.1875 9.5625H3.9375C3.78832 9.5625 3.64524 9.50324 3.53975 9.39775C3.43426 9.29226 3.375 9.14918 3.375 9C3.375 8.85082 3.43426 8.70774 3.53975 8.60225C3.64524 8.49676 3.78832 8.4375 3.9375 8.4375Z"
                fill="#074073"
              />
              <path
                d="M4.1704 9.00022L8.83578 13.6645C8.9414 13.7701 9.00074 13.9133 9.00074 14.0627C9.00074 14.2121 8.9414 14.3553 8.83578 14.461C8.73016 14.5666 8.5869 14.6259 8.43753 14.6259C8.28816 14.6259 8.1449 14.5666 8.03928 14.461L2.97678 9.39847C2.9244 9.34622 2.88283 9.28415 2.85448 9.21581C2.82612 9.14747 2.81152 9.07421 2.81152 9.00022C2.81152 8.92623 2.82612 8.85297 2.85448 8.78463C2.88283 8.7163 2.9244 8.65422 2.97678 8.60197L8.03928 3.53947C8.1449 3.43385 8.28816 3.37451 8.43753 3.37451C8.5869 3.37451 8.73016 3.43385 8.83578 3.53947C8.9414 3.64509 9.00074 3.78835 9.00074 3.93772C9.00074 4.08709 8.9414 4.23035 8.83578 4.33597L4.1704 9.00022Z"
                fill="#074073"
              />
            </svg>

            <p>Back</p>
          </div>
          <div className="text-[#074073] text-[20px] font-[700]">
            <p>Loan Appraisal Analysis Report</p>
          </div>
        </div>

        <div
          ref={reportRef}
          className="w-full max-w-[1188px] min-h-screen mx-auto mt-4 px-2 sm:px-6 lg:px-0 py-5 mb-10 rounded-[15px] border border-[#DCDCDC] bg-[#F8F8F8] opacity-100"
        >
          <div className="px-20 mt-16">
            <p className="text-[#074073] font-[600]">
              Loan Appraisal Report - M-PESA
            </p>
            <div className="flex items-center font-['Poppins'] text-[16px] mt-1">
              <span className="font-[300] text-[#4A4747]">LOAN ID:</span>
              <span className="ml-1 font-[600] text-[#316CE9]">
                #{loanCode}
              </span>
            </div>
            <div className="flex items-center font-['Poppins'] text-[16px] mt-1">
              <span className="font-[300] text-[#4A4747]">MEMBER:</span>
              <span className="ml-1 font-[400] text-[#000000]">
                {statementData?.data?.bio?.NAME}
              </span>
            </div>
            <div className="flex items-center font-['Poppins'] text-[16px] mt-1">
              <span className="font-[300] text-[#4A4747]">APPRAISAL DATE:</span>
              <span className="ml-1 font-[400] text-[#000000]">
                {new Date().toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </span>
            </div>
            <div className="flex items-center font-['Poppins'] text-[16px] mt-1">
              <span className="font-[300] text-[#4A4747]">DURATION:</span>
              <span className="ml-1 font-[400] text-[#000000]">
                {statementData?.data?.bio?.["STATEMENT DURATION"] || "N/A"}
              </span>
            </div>
            {statementType === "mpesa" && (
              <div className="">
                <div className="mt-4">
                  <span className="text-[24px] font-[600] text-[#042159]">
                    TRANSACTION METRICS
                  </span>
                  <div
                    className=""
                    style={{
                      borderBottom: "0.7px solid #4A4747",
                      width: "100%",
                    }}
                  ></div>

                  <div className="w-full flex gap-3 mt-2">
                    <div className="bg-[#FFFFFF] w-full h-[183px] rounded-[20px] px-4 flex flex-col">
                      <p className="text-[#000000] text-[15px] font-normal py-2 sm:py-5">
                        No. of Transactions
                      </p>
                      <p className="text-[#000000] text-[32px] font-normal py-2 sm:py-5">
                        {Number(
                          statementData?.data?.summary?.[
                            "TOTAL TRANSACTIONS"
                          ] || 0,
                        )?.toLocaleString()}
                      </p>
                    </div>
                    <div className="bg-[#FFFFFF] w-full h-[183px] rounded-[20px] px-4 flex flex-col">
                      <p className="text-[#000000] text-[15px] font-normal py-2 sm:py-5">
                        Total Paid In
                      </p>
                      <p className="text-[#000000] text-[28px] font-normal py-2 sm:py-5">
                        KES{" "}
                        {Number(
                          (
                            statementData?.data?.summary?.["TOTAL INFLOWS"] ||
                            "0.00"
                          ).replace(/,/g, ""),
                        ).toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </p>
                    </div>
                    <div className="bg-[#FFFFFF] w-full h-[183px] rounded-[20px] px-4 flex flex-col">
                      <p className="text-[#000000] text-[15px] font-normal py-2 sm:py-5">
                        Total Paid Out
                      </p>
                      <p className="text-[#000000] text-[28px] font-normal py-2 sm:py-5">
                        - KES{" "}
                        {Number(
                          (
                            statementData?.data?.summary?.["TOTAL OUTFLOWS"] ||
                            "0.00"
                          ).replace(/,/g, ""),
                        ).toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="mt-4">
                  <span className="text-[24px] font-[600] text-[#042159]">
                    PER MONTH CASH FLOW TRENDS - INFLOW (MONEY IN)
                  </span>
                  <div
                    className=""
                    style={{
                      borderBottom: "0.7px solid #4A4747",
                      width: "100%",
                    }}
                  ></div>

                  <div className="mt-4 flex gap-4 items-start">
                    {/* LEFT: SCROLLABLE TABLE */}
                    <div className="flex-1 bg-white rounded-[20px]">
                      {/* Table Header */}
                      <div className="bg-[#CBE6FF] mt-3 mx-2">
                        <div className="grid grid-cols-3 text-[#042159] font-[500] text-[14px] px-3 py-2">
                          <span>MONTH</span>
                          <span>WEEKLY AVERAGE (KES)</span>
                          <span>MONTHLY AVERAGE (KES)</span>
                        </div>
                      </div>

                      {/* Scrollable Body */}
                      <div className="max-h-[260px] overflow-y-auto">
                        {statementData?.data?.monthly?.map((item, i) => (
                          <div
                            key={i}
                            className="grid grid-cols-3 px-4 py-3 text-[14px] mt-2"
                          >
                            {/* MONTH */}
                            <span className="font-[600]">{item?.MONTH}</span>

                            {/* TOTAL WEEKLY INFLOW AVERAGE */}
                            <span>
                              {Number(
                                item["TOTAL WEEKLY INFLOW AVERAGE"] || 0,
                              )?.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </span>

                            {/* TOTAL MONTHLY INFLOW AVERAGE */}
                            <span>
                              {Number(
                                item["TOTAL MONTHLY INFLOW AVERAGE"] || 0,
                              )?.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* RIGHT: SMALL CONTENT-SIZED CARD */}

                    <div className="">
                      <div className="mt-3">
                        <span className="text-[#042159] font-[600]">
                          TOTAL INCOMES
                        </span>
                        <div
                          className=""
                          style={{
                            borderBottom: "0.7px solid #4A4747",
                            width: "100%",
                          }}
                        ></div>
                      </div>

                      <div className="w-[300px] rounded-[20px] bg-white mt-2 px-1 border border-[#FFFFFF]">
                        <div className="bg-[#CBE6FF] px-2 py-2 mt-2 flex justify-between text-[13px] font-[500] text-[#042159]">
                          <span>KEY CATEGORY</span>
                          <span>MONEY IN (KES)</span>
                        </div>

                        <div className="mt-3 mb-3 px-2 space-y-3 text-[14px]">
                          {/* P2P / Received Money */}
                          <div className="flex justify-between">
                            <span className="font-[600]">P2P Transfers</span>
                            <span>
                              {Number(
                                (
                                  statementData?.data?.summary?.[
                                    "RECEIVED MONEY"
                                  ] || "0"
                                ).replace(/,/g, ""),
                              ).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </span>
                          </div>

                          {/* Agent Deposits */}
                          <div className="flex justify-between">
                            <span className="font-[600]">Agent Deposits</span>
                            <span>
                              {Number(
                                (
                                  statementData?.data?.summary?.[
                                    "AGENT DEPOSIT"
                                  ] || "0"
                                ).replace(/,/g, ""),
                              ).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </span>
                          </div>

                          {/* Other Inflows */}
                          <div className="flex justify-between">
                            <span className="font-[600]">Other Inflows</span>
                            <span>
                              {Number(
                                (
                                  statementData?.data?.summary?.[
                                    "OTHERS INFLOWS"
                                  ] || "0"
                                ).replace(/,/g, ""),
                              ).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-4">
                  <span className="text-[24px] font-[600] text-[#042159]">
                    REVENUE & INFLOW ANALYSIS (MONEY IN)
                  </span>
                  <div
                    className=""
                    style={{
                      borderBottom: "0.7px solid #4A4747",
                      width: "100%",
                    }}
                  ></div>
                  <div className="bg-[#FFFFFF] mt-2">
                    <MoneyInBarChart statementData={statementData} />
                  </div>
                </div>

                <div className="mt-5">
                  <span className="text-[24px] font-[600] text-[#042159]">
                    PER MONTH CASH FLOW TRENDS - OUTFLOWS (MONEY OUT)
                  </span>
                  <div
                    className=""
                    style={{
                      borderBottom: "0.7px solid #4A4747",
                      width: "100%",
                    }}
                  ></div>
                  <div className="bg-white rounded-[20px] py-1 mt-2">
                    {/* Table Header */}
                    <div className="bg-[#CBE6FF] mt-1 mx-2">
                      <div className="grid grid-cols-3 text-[#042159] font-[500] text-[14px] px-3 py-2">
                        <span>MONTH</span>
                        <span>WEEKLY AVERAGE (KES)</span>
                        <span>MONTHLY AVERAGE (KES)</span>
                      </div>
                    </div>

                    {/* Scrollable Body */}
                    <div className="max-h-[260px] overflow-y-auto">
                      {statementData?.data?.monthly?.map((item, i) => (
                        <div
                          key={i}
                          className="grid grid-cols-3 px-4 py-3 text-[14px] mt-2"
                        >
                          {/* MONTH */}
                          <span className="font-[600]">{item?.MONTH}</span>

                          {/* TOTAL WEEKLY OUTFLOW AVERAGE */}
                          <span>
                            -{" "}
                            {Number(
                              item["TOTAL WEEKLY OUTFLOW AVERAGE"] || 0,
                            )?.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </span>

                          {/* TOTAL MONTHLY OUTFLOW AVERAGE */}
                          <span>
                            -{" "}
                            {Number(
                              item["TOTAL MONTHLY OUTFLOW AVERAGE"] || 0,
                            )?.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="flex flex-col md:flex-row gap-3 mt-2 items-stretch">
                    <div className="flex-1 flex flex-col">
                      <div className="mt-3">
                        <span className="text-[#042159] font-[600]">
                          TOTAL PAYMENTS
                        </span>
                        <div
                          style={{
                            borderBottom: "0.7px solid #4A4747",
                            width: "100%",
                          }}
                        ></div>
                      </div>

                      <div className="w-full flex-1 min-h-[200px] rounded-[20px] bg-white mt-2 px-2 border border-[#FFFFFF] flex flex-col">
                        <div className="bg-[#CBE6FF] px-3 py-2 mt-2 grid grid-cols-2 text-[13px] font-[500] text-[#042159]">
                          <span>KEY CATEGORY</span>
                          <span>MONEY OUT (KES)</span>
                        </div>

                        <div className="mt-3 mb-3 px-3 space-y-3 text-[14px] flex-1">
                          {[
                            {
                              label: "Paybills",
                              key: "LIPA NA M-PESA (PAYBILL)",
                            },
                            {
                              label: "Buy Goods (Till)",
                              key: "LIPA NA M-PESA (BUY GOODS)",
                            },
                            { label: "P2P Transfers", key: "SEND MONEY" },
                            {
                              label: "Agent Withdrawals",
                              key: "AGENT WITHDRAWAL",
                            },
                            {
                              label: "Airtime Purchases",
                              key: "AIRTIME PURCHASE TOTALS",
                            },
                            {
                              label: "Data Bundles",
                              key: "DATA BUNDLES TOTALS",
                            },
                          ]?.map(({ label, key }) => (
                            <div key={key} className="grid grid-cols-2">
                              <span className="font-[600]">{label}</span>
                              <span>
                                -
                                {Number(
                                  (statementData?.data?.summary?.[key] || "0")
                                    ?.toString()
                                    ?.replace(/,/g, ""),
                                )?.toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    <div className="flex-1 flex flex-col">
                      <div className="mt-3">
                        <span className="text-[#042159] font-[600]">
                          RISK BEHAVIOUR & DEBT OBLIGATIONS
                        </span>
                        <div
                          style={{
                            borderBottom: "0.7px solid #4A4747",
                            width: "100%",
                          }}
                        ></div>
                      </div>

                      <div className="w-full flex-1 min-h-[200px] rounded-[20px] bg-white mt-2 px-2 border border-[#FFFFFF] flex flex-col">
                        <div className="bg-[#CBE6FF] px-2 py-2 mt-2 grid grid-cols-2 gap-x-24 text-[13px] font-[500] text-[#042159]">
                          <span>KEY CATEGORY</span>
                          <span>MONEY OUT (KES)</span>
                        </div>

                        <div className="mt-3 mb-3 px-2 space-y-3 text-[14px] flex-1">
                          {/* Mobile Loans / Fuliza */}
                          <div className="grid grid-cols-2 gap-x-24">
                            <span className="font-[600]">
                              Mobile Loans (Fuliza)
                            </span>
                            <span>
                              -
                              {Number(
                                (
                                  statementData?.data?.summary?.[
                                    "FULIZA TOTALS"
                                  ] || 0
                                )
                                  .toString()
                                  .replace(/,/g, ""),
                              ).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </span>
                          </div>

                          {/* Loan Repayments */}
                          <div className="grid grid-cols-2 gap-x-24">
                            <span className="font-[600]">Loan Repayments</span>
                            <span>
                              -
                              {Number(
                                (
                                  statementData?.data?.summary?.[
                                    "LOAN TOTALS"
                                  ] || 0
                                )
                                  .toString()
                                  .replace(/,/g, ""),
                              ).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-4">
                  <span className="text-[24px] font-[600] text-[#042159]">
                    REVENUE & OUTFLOW ANALYSIS (MONEY OUT)
                  </span>
                  <div
                    className=""
                    style={{
                      borderBottom: "0.7px solid #4A4747",
                      width: "100%",
                    }}
                  ></div>
                  <div className="bg-[#FFFFFF] mt-2">
                    <MoneyOutBarChart statementData={statementData} />
                  </div>
                </div>
              </div>
            )}
            {statementType === "bank" && (
              <div className="">
                <div className="mt-4">
                  <span className="text-[24px] font-[600] text-[#042159]">
                    CONSOLIDATED BANKING PERFORMANCE (6-MONTH LOOKBACK)
                  </span>
                  <div
                    className=""
                    style={{
                      borderBottom: "0.7px solid #4A4747",
                      width: "100%",
                    }}
                  ></div>

                  <div className="w-full flex gap-3 mt-2">
                    <div className="bg-[#FFFFFF] w-full h-[183px] rounded-[20px] px-4 flex flex-col">
                      <p className="text-[#074073] text-[14px] font-normal py-2 sm:py-5">
                        AVG Total Monthly <br />
                        Deposits
                      </p>
                      <p className="text-[#000000] text-[32px] font-normal py-2 sm:py-5">
                        {toNumber(
                          statementData?.data?.summary?.[
                            "TOTAL MONTHLY AVERAGE"
                          ],
                        ).toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </p>
                    </div>
                    <div className="bg-[#FFFFFF] w-full h-[183px] rounded-[20px] px-4 flex flex-col">
                      <p className="text-[#074073] text-[14px] font-normal py-2 sm:py-5">
                        AVG Total Monthly
                        <br />
                        Outflows
                      </p>
                      <p className="text-[#000000] text-[28px] font-normal py-2 sm:py-5">
                        {toNumber(
                          statementData?.data?.summary?.["TOTAL OUTFLOWS"],
                        ).toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </p>
                    </div>
                    <div className="bg-[#FFFFFF] w-full h-[183px] rounded-[20px] px-4 flex flex-col">
                      <p className="text-[#074073] text-[15px] font-normal py-2 sm:py-5">
                        AVG Net Cash Flow
                        <br />
                        (Surplus)
                      </p>
                      <p className="text-[#000000] text-[28px] font-normal py-2 sm:py-5">
                        {toNumber(
                          statementData?.data?.summary?.["TOTAL SURPLUS"],
                        ).toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </p>
                    </div>
                    <div className="bg-[#FFFFFF] w-full h-[183px] rounded-[20px] px-4 flex flex-col">
                      <p className="text-[#074073] text-[14px] font-normal py-2 sm:py-5">
                        Average Daily
                        <br />
                        Balance (ADB)
                      </p>
                      <p className="text-[#000000] text-[28px] font-normal py-2 sm:py-5">
                        {toNumber(
                          statementData?.data?.summary?.["TOTAL INFLOWS"],
                        )?.toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="mt-5">
                  <span className="text-[24px] font-[600] text-[#042159]">
                    SIX-MONTH CASH FLOW SUMMARY (KES)
                  </span>
                  <div
                    className=""
                    style={{
                      borderBottom: "0.7px solid #4A4747",
                      width: "100%",
                    }}
                  ></div>
                  <div className="bg-white rounded-[20px] py-1 mt-2">
                    {/* Table Header */}
                    <div className="bg-[#CBE6FF] mt-1 mx-2">
                      <div className="grid grid-cols-5 text-[#042159] uppercase font-[500] text-[14px] px-3 py-2">
                        <span>Month</span>
                        <span>Total Inflows</span>
                        <span>Total Outflows</span>
                        <span>Net Surplus</span>
                        <span>Ending Balance</span>
                      </div>
                    </div>

                    {/* Scrollable Body */}
                    <div className="max-h-[260px] overflow-y-auto">
                      {statementData?.data?.monthly?.map((item, i) => (
                        <div
                          key={i}
                          className="grid grid-cols-5 px-4 py-3 text-[14px] items-center"
                        >
                          {/* MONTH */}
                          <span className="font-[600]">{item?.MONTH}</span>

                          {/* TOTAL INFLOWS */}
                          <span>
                            {Number(
                              item?.["TOTAL INFLOWS"] || 0,
                            )?.toLocaleString("en-US")}
                          </span>

                          {/* TOTAL OUTFLOWS */}
                          <span>
                            {Number(
                              item?.["TOTAL OUTFLOWS"] || 0,
                            )?.toLocaleString("en-US")}
                          </span>

                          {/* NET SURPLUS */}
                          <span>
                            {Number(
                              item?.["TOTAL NET SURPLUS"] || 0,
                            )?.toLocaleString("en-US")}
                          </span>

                          {/* ENDING BALANCE */}
                          <span>
                            {Number(
                              item?.["ENDING BALANCE"] || 0,
                            )?.toLocaleString("en-US")}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default LoanApprasialReport;
